// Privacy.js

import React, { Component } from 'react';
import { Button, Form, Table } from 'react-bootstrap';
import Config from '../Config';
import "./Terms.css";

class RowItem extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            answervisible: false
        };
    }

    handleRowClick = () => {
        this.props.onPress(this.props.item);
        event.preventDefault();
    }
    render() {
        return (
            <tr onClick={this.handleRowClick}>
                <td>{this.props.item.ID}</td>
                <td>{this.props.item.TITLE}</td>
                <td width="60%"><pre>{this.props.item.CONTENT.substr(0, 300)}</pre></td>
                <td>{this.props.item.LANG}</td>
                <td>{this.props.item.UPDATE}</td>
            </tr>
        );
    }
};

export default class Legal extends Component {
    constructor(props) {
        super(props);
        this.default = { TITLE: '제목을 입력하세요.', CONTENT: '내용을 입력하세요.', LANG: Config.defaultLANG };
        this.state = {
            sendcount: 0,
            itemlist: [],
            answervisible: false,
            item: { ...this.default }
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeContent = this.handleChangeContent.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleChangeLang = this.handleChangeLang.bind(this);
        this.handleChangeCountry = this.handleChangeCountry.bind(this);
    }

    handleReset(event) {
        this.setState({ item: { ...this.default } })
    }

    handleChange(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeContent(event) {
        var item = this.state.item;
        item.CONTENT = event.target.value;
        this.setState({ item: item });
    }

    handleChangeLang(event) {
        var item = this.state.item;
        item.LANG = event.target.value;
        this.setState({ item: item });
    }

    handleChangeCountry(event) {
        this.setState({ country: event.target.value });
    }

    fetchData(address, params, callback, revalidate = false, cbError) {

        var chcheoption = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (revalidate) {
            // chcheoption['Cache-Control'] = 'must-revalidate';
        }

        fetch(`${Config.Server}/${address}`, {
            // mode: 'no-cors',
            method: 'POST',
            headers: chcheoption,
            body: JSON.stringify(params)
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (callback)
                    callback(responseJson.result, responseJson.count);
            })
            .catch((error) => {
                console.error(error);
                if (cbError)
                    cbError(error);
            });
    }

    handleSubmit(event) {

        this.fetchData('inslegal', {
            COUNTRY: this.state.item.COUNTRY,
            LANG: this.state.item.LANG,
            TITLE: this.state.item.TITLE,
            CONTENT: this.state.item.CONTENT
        }, (result, count) => {
            console.log('inslegal=', count);
            this.setState({ sendcount: count });
            this.componentDidMount();
        }, true);

        event.preventDefault();
    }

    handleRemove(event) {

        var result = confirm("삭제 할까요?");
        if (result) {
            this.fetchData('dellegal', {
                ID: this.state.item.ID,
                COUNTRY: this.state.item.COUNTRY,
                LANG: this.state.item.LANG
            }, (result, count) => {
                console.log('dellegal=', count);
                this.setState({ sendcount: count });
                this.componentDidMount();
            }, true);
        }

        event.preventDefault();
    }

    handleRowClick = (item) => {
        // alert(item);
        var edititem = { ...item };
        edititem.TITLE = item.TITLE;
        edititem.CONTENT = item.CONTENT;
        this.setState({ item: edititem });
        this.setState({ answervisible: true });
        event.preventDefault();
    }

    componentDidMount() {
        this.fetchData('legalall', {
        }, (result, count) => {
            console.log('count=', count);
            this.setState({ itemlist: result })
        }, true);
    }

    render() {
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <h3 className="box-title">법적고지 등록/수정</h3>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    <div className="row">

                                        <Form>
                                            <Form.Group controlId="exampleForm.ControlInput1">
                                                <Form.Label>제목</Form.Label>
                                                <Form.Control type="title" placeholder="제목을 입력하세요." value={this.state.item.TITLE} onChange={this.handleChange} />
                                            </Form.Group>
                                            <Form.Group controlId="exampleForm.ControlSelect1">
                                                <Form.Label>언어선택</Form.Label>
                                                <Form.Control as="select" value={this.state.item.LANG} onChange={this.handleChangeLang}>
                                                    {Config.ProductLangs.map((item, index) =>
                                                        <option>{item}</option>
                                                    )}
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group controlId="exampleForm.ControlTextarea1">
                                                <Form.Label>내용</Form.Label>
                                                <Form.Control as="textarea" rows="5" value={this.state.item.CONTENT} onChange={this.handleChangeContent} />
                                            </Form.Group>
                                            <Button variant="primary" onClick={this.handleSubmit}>등록/수정</Button>
                                            <Button variant="primary" onClick={this.handleReset}>리셋</Button>
                                            <Button variant="primary" onClick={this.handleRemove}>삭제</Button>
                                        </Form>

                                    </div>
                                    <div className="row Terms">

                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>제목</th>
                                                    <th>내용</th>
                                                    <th>언어</th>
                                                    <th>등록일</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.itemlist.map((item, index) =>
                                                    <RowItem key={index} item={item} onPress={this.handleRowClick} />
                                                )}
                                            </tbody>
                                        </Table>

                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                {/* <span className="description-percentage text-green"><i className="fa fa-caret-up"></i> 17%</span> */}
                                                {/* <h5 className="description-header">Sending TOTAL: {this.state.sendcount}</h5> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/Legal.js